<template lang="pug">
  .stat-tile(:style="{ color }")
    .line(:style="{ background: color }")
    .doughnut-wrap
      .doughnut-content
        | {{ Math.round(this.value / this.max * 100) }}%
        br
        span использовано
      Doughnut(
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :plugins="plugins"
        :width="130"
        :height="130"
      )
    .data
      .title {{ title }}
      .stat.total
        .value {{ max }}
        .label {{ unit }} <br> доступно
      .stat.total
        .value {{ Math.round(value * 10) / 10 }}
        .label {{ unit }} <br> использовано
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy';

import {
  Chart as ChartJS,
  ArcElement,
} from 'chart.js';

ChartJS.register(ArcElement);

export default {
  name: 'PersonalStatTile',
  components: { Doughnut },
  props: {
    title: { type: String, default: 'Заголовок' },
    unit: { type: String, default: 'штук' },
    max: { type: Number, default: 100 },
    value: { type: Number, default: 45 },
    color: { type: String, default: 'red' },
  },
  computed: {
    chartId() { return this._id; }, // eslint-disable-line no-underscore-dangle
    plugins() {
      return [];
    },
    chartData() {
      return {
        datasets: [
          {
            backgroundColor: [this.color, '#EBEFF2'],
            data: [this.value, this.max - this.value],
            borderWidth: [0, 0],
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        borderRadius: 50,
        cutout: '76%',
        hover: { mode: null },
        plugins: {
          tooltip: { enabled: false },
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
  .stat-tile {
    background: #FFFFFF;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    padding: 30px 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 35px;
    position: relative;
    overflow: hidden;

    @media (max-width: 576px) {
      margin-left: -15px;
      margin-right: -15px;
      border-radius: 0;
    }
  }

  .line {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 5px;
    opacity: .3;

    @media (max-width: 576px) {
      display: none;
    }
  }

  .doughnut-wrap {
    border-radius: 50%;
    background: #EBEFF2;
    position: relative;
    display: inline-block;
    grid-row: 1 / 3 span;
  }

  .doughnut-content {
    position: absolute;
    z-index: 1;
    top: 12%;
    left: 12%;
    right: 12%;
    bottom: 12%;
    border-radius: 50%;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    font-weight: 700;
    font-size: 26px;
    line-height: 1;
    letter-spacing: 0.01em;

    span {
      font-weight: 400;
      font-size: 10px;
      line-height: 11px;
      letter-spacing: 0.02em;
      color: #000000;
    }
  }

  .title {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #1E3147;
  }

  .stat {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 5px 0;

    .value {
      font-weight: 700;
      font-size: 30px;
      line-height: 38px;
      letter-spacing: 0.01em;
    }

    .label {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: #788CA1;
    }
  }
</style>
